import { FC, Fragment } from 'react';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import FormGroup from 'components/FormGroup';
import Checkbox from 'components/forms/Checkbox';
import FormSelect, { OptionItem } from 'components/FormSelect';
import type { CustomerInfoKeyType } from 'types/customer';
import config from 'utils/config';
import './style.scss';

export const defaultFieldsOfInvestTarget: CustomerInfoKeyType[] = ['invest_target'];

export interface InvestTargetFieldType {
    invest_target: string;
}

interface InvestTargetProps {
    disabled?: boolean;
    $formutil: $Formutil<InvestTargetFieldType>;
}

export const investTargets: Array<{
    id: string;
    text?: string;
    marscoText: string;
}> = [
    {
        id: '0,1',
        marscoText: __('Trading for Profits (High Risk Tolerance)')
    },
    { id: '2,3', text: __('Growth & Hedging'), marscoText: __('Preservation and Growth (Medium Risk Tolerance)') },
    {
        id: '4,5',
        marscoText: __('Capital Preservation Only (Low Risk Tolerance)')
    }
];
export const investTargetOptions: OptionItem[] = investTargets.map(item => ({
    value: item.id,
    label: item.marscoText
}));

const InvestTarget: FC<InvestTargetProps> = props => {
    const { disabled } = props;

    return (
        <Fragment>
            <h4 className="mt-4 mb-3">{__('Investment Objective')}</h4>
            <FormGroup
                name="invest_target"
                label={__('Investment Objective')}
                className="invest-targets-field-root"
                required={!disabled}
                validMessage={{
                    required: config.selectError(__('investment objective'))
                }}>
                <FormSelect placeholder={__('Please Select')} disabled={disabled} options={investTargetOptions} />
            </FormGroup>
            <Checkbox
                name="temporary_invest_target_check"
                $defaultValue={true}
                checker={value => !!value || __('请您阅读并同意上述协议')}
                label={<>* {__('I understand that my trading strategies are at my own discretion')}</>}
                disabled={disabled}
            />
        </Fragment>
    );
};

export default connect(InvestTarget);
